import { Component, OnInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';

import { FieldComponent } from './field.component';
import { OffsetDialogComponent } from './offset-dialog.component';

@Component({
  selector: 'app-offset-field',
  templateUrl: './offset-field.component.html',
  styleUrls: ['./offset-field.component.scss']
})
export class OffsetFieldComponent extends FieldComponent implements OnInit {

  @Output() timecodesOffsetChanged = new EventEmitter<string>();

  id: string = 'offset';
  standard: any;

  get valid(): boolean {return true}

  constructor(
    cd: ChangeDetectorRef,
    private dialog: MatDialog) { super(cd) }

  ngOnInit() {
    if (this.field.locked) { this.locked = true }
  }

  setStandard(standard) {
    this.standard = standard;
  }

  showInputDialog() {
    if (this.standard == null) { return }
    let dialogRef = this.dialog.open(OffsetDialogComponent, {
      height: '240px',
      width: '320px',
      data: {}
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != null) {
        this.timecodesOffsetChanged.emit(result)
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/app/forms/offset-field.component.ts